const reduceCallback = (accumulator, current) =>
	current?.contacts ? [...accumulator, ...current.contacts] : [...accumulator];

export default (entities) => entities.reduce(reduceCallback, []);
